import { render, staticRenderFns } from "./App.vue?vue&type=template&id=856e7c48&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "@/style/table.less?vue&type=style&index=0&id=856e7c48&prod&lang=less&scoped=true&external"
import style1 from "./App.vue?vue&type=style&index=1&id=856e7c48&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856e7c48",
  null
  
)

export default component.exports